<script lang="ts">
  import { onDestroy } from "svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
  import {
    prepareObjectUrlDownload,
    triggerObjectUrlDownload,
    type PreparedDownload,
  } from "../../../../../../../../../../../../../../_shared/_logic/object-url-download"
  import type { DownloadStreetListsOperations } from "../../actions/downloadStreetLists"
  import { downloadStreetListsOperations } from "./operations"

  const {
    organizationId,
    jobId,
    statusToken,
    operations = downloadStreetListsOperations,
    onDownloaded,
  }: {
    organizationId: string
    jobId: string
    statusToken: string
    operations?: DownloadStreetListsOperations
    onDownloaded: () => void
  } = $props()

  let downloading = $state(false)
  let controller: AbortController | null = null

  const download = async () => {
    if (downloading) return

    downloading = true
    const nextController = new AbortController()
    controller?.abort()
    controller = nextController
    const prepared: PreparedDownload[] = []
    const requests = [
      Promise.resolve().then(() =>
        operations.download({
          organizationId,
          jobId,
          audience: "admin",
          statusToken,
          signal: nextController.signal,
        }),
      ),
      Promise.resolve().then(() =>
        operations.download({
          organizationId,
          jobId,
          audience: "employee",
          statusToken,
          signal: nextController.signal,
        }),
      ),
    ] as const
    try {
      const [admin, employee] = await Promise.all(requests)

      if (nextController.signal.aborted) return

      prepared.push(
        prepareObjectUrlDownload(admin.blob, admin.contentDisposition, "strassenliste-chef.csv"),
        prepareObjectUrlDownload(
          employee.blob,
          employee.contentDisposition,
          "strassenliste-geselle.csv",
        ),
      )
      prepared.forEach(triggerObjectUrlDownload)
      onDownloaded()
    } catch {
      const alreadyAborted = nextController.signal.aborted
      nextController.abort()
      await Promise.allSettled(requests)

      if (alreadyAborted) return

      newNotification({
        class: "error",
        html: "Die beiden ISI-Exporte konnten nicht vollständig geladen werden. Bitte versuchen Sie es erneut.",
      })
    } finally {
      prepared.forEach(({ objectUrl }) =>
        window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0),
      )

      if (controller === nextController) controller = null

      downloading = false
    }
  }

  onDestroy(() => controller?.abort())
</script>

<CTA
  type="primaryButton"
  content={downloading ? "ISI-Exporte werden geladen…" : "ISI-Exporte downloaden"}
  onClick={download}
  disabled={downloading}
/>
